import React from 'react';

/**
 * Custom CSS fixes for proper A4 rendering and centering
 */

// Add these styles to your project to fix the print/PDF layout issues
const reportStyles = `
/* A4 size preview container - maintains aspect ratio */
.a4-preview-container {
  width: 210mm;
  max-width: 100%;
  height: auto;
  aspect-ratio: 210 / 297;
  margin: 0 auto;
  background-color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

/* A4 size container for PDF generation/printing */
.a4-page {
  width: 210mm;
  height: 297mm;
  position: relative;
  margin: 0 auto;
  background-color: white;
  padding: 0;
  box-sizing: border-box;
  page-break-after: always;
  break-after: page;
}

/* Content wrapper that centers everything properly */
.report-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 10mm;
  box-sizing: border-box;
}

/* Ensure SVGs and decorative elements render properly */
.report-content-wrapper svg, 
.report-content-wrapper .svg-element {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Fixes for tables to ensure they take full width and preserve colors */
.report-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.report-table th, 
.report-table td {
  padding: 8px;
  border: 1px solid #e2e8f0;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

/* Media query for print */
@media print {
  @page {
    size: A4 portrait;
    margin: 0;
  }
  
  body {
    margin: 0;
    padding: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .a4-page {
    page-break-after: always;
    break-after: page;
    margin: 0 !important;
  }
  
  /* Hide all UI elements */
  header, nav, button, 
  .fixed, .sticky, 
  .print-hidden, 
  [class*="sidebar"], 
  [class*="navigation"] {
    display: none !important;
  }
  
  /* Fix Tailwind backgrounds for print */
  .bg-sky-200 { background-color: #bae6fd !important; }
  .bg-blue-100 { background-color: #dbeafe !important; }
  .bg-blue-800 { background-color: #1e40af !important; }
  .bg-amber-50 { background-color: #fffbeb !important; }
  .bg-amber-100 { background-color: #fef3c7 !important; }
  .bg-amber-200 { background-color: #fde68a !important; }
  .bg-red-200 { background-color: #fecaca !important; }
  
  /* Fix Tailwind text colors for print */
  .text-blue-800 { color: #1e40af !important; }
  .text-gray-700 { color: #374151 !important; }
}
`;

// const ReportPageWrapper = ({ children, pageNumber }) => {
//   return (
//     <div className="flex justify-center items-center w-full h-full">
//       <div
//         className="relative shadow-xl overflow-hidden origin-top"
//         style={{
//           width: '210mm',
//           height: '297mm',
//           maxWidth: '100%',
//           maxHeight: '95vh',
//           transform: 'scale(0.98)', // Slightly scale down to ensure full visibility
//           transformOrigin: 'top center'
//         }}
//       >
//         {children}
//         {pageNumber && (
//           <div className="absolute bottom-3 right-4 text-gray-600 font-medium">
//             {pageNumber} / 12
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };


const ReportPageWrapper = ({ children, pageNumber }) => {
  return (
    <div className="flex justify-center font-[poppins] items-center w-full h-full">
      <div
        className="relative shadow-xl overflow-hidden print:shadow-none"
        style={{
          width: '210mm',
          height: '297mm',
          maxWidth: '100%',
          maxHeight: '98vh',
          transform: 'scale(0.98)',
          transformOrigin: 'top center',
          '@media print': {
            transform: 'none',
            height: '297mm',
            width: '210mm',
          }
        }}
      >
        {children}
        {pageNumber && (
          <div className="absolute bottom-3 right-4 text-gray-600 font-medium print:text-black">
            {pageNumber} / 12
          </div>
        )}
      </div>
    </div>
  );
};

// Wrapper for normal viewing in the UI
const PreviewPageWrapper = ({children, currentPage, totalPages}) => {
    return (
        <div className="a4-preview-container">
            <div className="report-content-wrapper">
                {children}

                {/* Page indicator */}
                <div className="absolute bottom-2 right-4 bg-gray-200 px-3 py-1 rounded-full text-sm">
                    {currentPage + 1} / {totalPages}
                </div>
            </div>
        </div>
    );
};

// Helper function to add these styles to the document
const addReportStyles = () => {
    if (document.getElementById('report-styles')) return;

    const style = document.createElement('style');
    style.id = 'report-styles';
    style.textContent = reportStyles;
    document.head.appendChild(style);
};

export {
    ReportPageWrapper,
    PreviewPageWrapper,
    addReportStyles,
    reportStyles
};